/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Tea_Machines_Stale_Warning_Without_Request_IdInputs */

const vi_tea_machines_stale_warning_without_request_id = /** @type {(inputs: Tea_Machines_Stale_Warning_Without_Request_IdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mất kết nối máy vò từ ${i?.time} — số liệu đang hiển thị là cũ.`)
};

/**

* @param {Tea_Machines_Stale_Warning_Without_Request_IdInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_machines_stale_warning_without_request_id = /** @type {((inputs: Tea_Machines_Stale_Warning_Without_Request_IdInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Machines_Stale_Warning_Without_Request_IdInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_machines_stale_warning_without_request_id(inputs)
});